import React, {Component} from 'react';
import PropTypes from 'prop-types';
import size from 'lodash/size';
import debounce from 'lodash/debounce';
import {Button} from 'react-bootstrap';
import classNames from 'classnames';
import Mousetrap from 'mousetrap';
import ReactTooltip from 'react-tooltip';

export default class SelectionNav extends Component {
    static propTypes = {
        urlPrefix: PropTypes.string,
        images: PropTypes.array,
        currentIdx: PropTypes.number,
        prevId: PropTypes.number,
        nextId: PropTypes.number,
        position: PropTypes.shape({
            x: PropTypes.number,
            y: PropTypes.number,
        }),
        onSelectionNavDrag: PropTypes.func,
        history: PropTypes.object,
        preventKeyNavigation: PropTypes.bool,
    };

    static defaultProps = {
        urlPrefix: '',
    };

    constructor(props) {
        super(props);
        const {x, y} = props.position;
        this.defaultPosition = {x, y};
        this.handleNavDebounced = debounce(this.handleNav, 300);
    }

    componentDidMount() {
        Mousetrap.bind(['up'], (e) => {
            if (!this.props.preventKeyNavigation) {
                e.preventDefault();
                this.handlePrev();
            }
        });
        Mousetrap.bind(['down'], (e) => {
            if (!this.props.preventKeyNavigation) {
                e.preventDefault();
                this.handleNext();
            }
        });
    }

    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['up', 'down']);
    }

    handleNav = (id, e) => {
        if (e) {
            e.preventDefault();
        }
        const {history, urlPrefix} = this.props;
        history.push(`${urlPrefix}/image/${id}`);
    };

    handlePrev = (e) => {
        if (this.props.prevId) {
            this.handleNavDebounced(this.props.prevId, e);
        }
    };

    handleNext = (e) => {
        if (this.props.nextId) {
            this.handleNavDebounced(this.props.nextId, e);
        }
    };

    handleDragStop = (e, ui) => {
        this.props.onSelectionNavDrag(ui.x, ui.y);
    };

    render() {
        const {images, currentIdx, nextId, prevId} = this.props;
        const sz = size(images);

        const notSelected = currentIdx < 0;
        const messageControl = notSelected ?
            <div className="selection-nav-counts pull-left">{'not selected'}</div> :
            <div className="selection-nav-counts pull-left">{`${currentIdx + 1} of ${sz}`}</div>;

        return (
            <div className={classNames('selection-nav', {'not-selected': notSelected})}>
                <Button
                    bsStyle="link" onClick={this.handlePrev} disabled={!prevId}
                    title={nextId ? '' : 'Previous Selected'}
                    data-tip data-for="upTooltip"
                >
                    <i className="fa fa-chevron-circle-up"/>
                    {prevId &&
                    <ReactTooltip id="upTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                        <div>{'Previous Selected'}</div>
                        <kbd>{'↑'}</kbd>
                    </ReactTooltip>
                    }
                </Button>
                {messageControl}
                <Button
                    bsStyle="link" onClick={this.handleNext} disabled={!nextId}
                    title={nextId ? '' : 'Next Selected'}
                    data-tip data-for="downTooltip"
                >
                    <i className="fa fa-chevron-circle-down"/>
                    {nextId &&
                    <ReactTooltip id="downTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                        <div>{'Next Selected'}</div>
                        <kbd>{'↓'}</kbd>
                    </ReactTooltip>
                    }
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectionNav.js